import {
  faVolumeHigh,
  faVolumeXmark,
} from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "../../Icon/Icon";
import { TileButton, TileButtonProps } from "./TileButton";

interface TileMuteButtonProps extends Omit<TileButtonProps, "aria-label"> {
  isMuted: boolean;
  onAction: (event: React.MouseEvent, action: "TOGGLE_MUTE") => void;
  "aria-label"?: string;
}

const getAriaLabel = (isMuted: boolean, disabled: boolean) => {
  if (disabled) return "No audio available.";
  else if (isMuted) return "Unmute";
  else return "Mute";
};

export const TileMuteButton = (props: TileMuteButtonProps) => {
  const { isMuted, disabled, onAction, ...rest } = props;

  const handleAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAction(e, "TOGGLE_MUTE");
  };

  return (
    <TileButton
      aria-label={getAriaLabel(isMuted, disabled ?? false)}
      variant="primary"
      disabled={disabled}
      onClick={handleAction}
      {...rest}
    >
      <Icon size="medium" icon={isMuted ? faVolumeXmark : faVolumeHigh} />
    </TileButton>
  );
};
